import * as React from 'react';
import { Typography } from '@material-ui/core';
import { Root, RouteList, UploadForRiskJudge } from '../containers';

const uploadDocumentPage: React.SFC = () => {
  return (
    <Root routeList={<RouteList />}>
      <Typography variant="h5" gutterBottom>
        リスクチェック<br />
      </Typography>
      <Typography variant="h6" gutterBottom>
        　・MEC標準と違う内容、契約上のリスクは含まれているか？<br />
        <br />
        リスクチェックを行うファイルをアップロードしてください
      </Typography>
      <UploadForRiskJudge />
    </Root>
  );
};

export default uploadDocumentPage;



// WEBPACK FOOTER //
// ./src/pages/uploadForRiskJudge.tsx